






































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import ContactInput from '../common/ContactInput.vue';

import { UserType } from '../../types/UserType';
import { CountryType } from '../../types/CountryType';
import UserService from '../../services/UserService';

import { bus } from '../../main';

const user = namespace('user');
const country = namespace('country');

type Error = {
  firstName?: string;
  lastName?: string;
  phone?: string;
  company?: string;
  street?: string;
  city?: string;
  zip?: string;
  website?: string;
};

@Component({
  components: {
    'contact-input': ContactInput,
  },
})
export default class Contact extends Vue {
  @user.State
  public user!: UserType;

  @user.Mutation
  public setUser!: (user: UserType) => void;

  @country.State
  public countries!: CountryType[];

  @country.Getter
  public currentCountry!: CountryType;

  private userClone?: any;

  private errors: Error = {};

  private isDataChanged = false;

  @Watch('user')
  onUserChanged(val: UserType, oldVal: UserType) {
    this.userClone = this.clone(val);
  }

  created() {
    this.userClone = this.clone(this.user);
  }

  // eslint-disable-next-line class-methods-use-this
  private clone(value: UserType) {
    if (value === undefined) return {};
    return JSON.parse(JSON.stringify(value));
  }

  private cancelChanges() {
    this.userClone = this.clone(this.user);
    this.isDataChanged = false;
    this.errors = {};
  }

  private saveChanges() {
    if (Object.keys(this.errors).length !== 0) {
      bus.$emit('onShowNotification', this.$t('notification.fillFields'));
      return;
    }
    this.isDataChanged = false;

    UserService.update(this.user.id, this.userClone)
      .then((res) => {
        this.setUser(res.data);
        bus.$emit('onShowNotification', this.$t('notification.contactUpdated'));
      })
      .catch((e) => {
        bus.$emit('onShowNotification', this.$t('notification.somethingWrong'));
        console.log(e);
      });
  }

  private onChangeInput(e: any) {
    this.isDataChanged = true;
    const { name, value } = e.target;

    if (['street', 'city', 'zip', 'country'].includes(name)) {
      this.userClone!.address[name] = value;
    } else {
      this.userClone[name] = value;
    }

    this.errors = this.validateFields();
  }

  private validateFields() {
    const errors: Error = {};

    if (this.userClone!.firstName === '') {
      errors.firstName = this.$t('errors.firstName') as string;
    }
    if (this.userClone!.lastName === '') {
      errors.lastName = this.$t('errors.lastName') as string;
    }

    if (this.userClone!.phone.length < 5) {
      errors.phone = this.$t('errors.phone') as string;
    }

    if (this.userClone!.company === '') {
      errors.company = this.$t('errors.company') as string;
    }

    if (this.userClone!.address.street === '') {
      errors.street = this.$t('errors.street') as string;
    }

    if (this.userClone!.address.city === '') {
      errors.city = this.$t('errors.city') as string;
    }

    if (this.userClone!.address.zip === '') {
      errors.zip = this.$t('errors.zip') as string;
    }

    if (this.userClone!.website === '') {
      errors.website = this.$t('errors.website') as string;
    }

    return errors;
  }
}
